import { render, staticRenderFns } from "./PanelForm.vue?vue&type=template&id=27b21b7c&"
import script from "./PanelForm.vue?vue&type=script&lang=js&"
export * from "./PanelForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelForm.vue?vue&type=style&index=0&id=27b21b7c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b21b7c')) {
      api.createRecord('27b21b7c', component.options)
    } else {
      api.reload('27b21b7c', component.options)
    }
    module.hot.accept("./PanelForm.vue?vue&type=template&id=27b21b7c&", function () {
      api.rerender('27b21b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/PanelForm.vue"
export default component.exports